import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router"
import { LoginService } from 'src/app/service/login.service';
// import { qrCode } from './qrcode';
import { RedirectHelper } from 'src/app/manager/redirect';
import { NotificationService } from 'src/app/service/notification.service';
import { CommonService } from 'src/app/service/common-service';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
interface JwtPayload {
  [x: string]: string;
  Employee_Code: string;
  Clients: any;
}
 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
@Component({
  selector: 'app-two-factor-auth',
  templateUrl: './two-factor-auth.component.html',
  styleUrls: ['./two-factor-auth.component.scss'],
  standalone: true,
  imports: [HeaderComponent, FormsModule, CommonModule,AgGridModule]
})
export class TwoFactorAuthComponent implements OnInit, OnDestroy {
  token = null;
  activeUser = null;
  URI = null;
  barCodeURI = null;
  passcode = null;
  // RedirectHelper: RedirectHelper;
  constructor(
    private router: Router,
    private loginService: LoginService,
    private RedirectHelper: RedirectHelper,
    private notification: NotificationService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.getTokenFromLocal();
    // this.RedirectHelper = new RedirectHelper(this.router)
  }

  getTokenFromLocal() {
    this.token = CommonService.decryptData(localStorage.getItem('token'));
    const enableTFAuthStr = sessionStorage.getItem('enableTFAuth');
    console.log('token : ', this.token);
    if (this.token != null && this.token.length > 0) {
      this.activeUser = jwt_decode(this.token);
      
      this.activeUser.enableTFAuth = enableTFAuthStr ? JSON.parse(enableTFAuthStr) : null;
      const { enableTFAuth } = this.activeUser;
      console.log('After decode data : ', this.activeUser);
      if (enableTFAuth && enableTFAuth.status && enableTFAuth.status == 'incomplete') {
        this.getQRCode();
      }
      // else {
      //   this.router.navigate(['/login']);
      //   this.clearMe();
      // }
    }
    else {
      this.router.navigate(['/login']);
      this.clearMe();
    }
  }

  ngOnDestroy() {
    console.log('ngOnDestroy : ')
    localStorage.clear();
    sessionStorage.removeItem("enableTFAuth");
  }
  clearMe() {
    localStorage.clear();
    sessionStorage.removeItem("enableTFAuth");

  }
  getQRCode() {
    console.log('QR code API');
    this.loginService.getQRCode(this.activeUser.Email_Id, this.activeUser.User_Id).subscribe((response: any) => {
      console.log('getQRCode response : ', response);
      this.barCodeURI = response.Data.Html;
    }, (error) => {
      console.log('error : ', error)
    });

  }

  submit() {
    console.log('submit user : ', this.activeUser);
    const randomNumber: number = Math.floor(100000 + Math.random() * 900000);
    const indexNumber: number= Math.floor(Math.random() * 5)
    const key: string = `${indexNumber}${randomNumber}`;
    if (this.passcode && this.passcode != null) {
      const passcodeEncrypted = this.commonService.encryptData(this.passcode.toString());
      var obj = new Object();
      obj['Pin'] = passcodeEncrypted;
      obj['UserId'] = this.activeUser.User_Id
      obj['EmailId'] = this.activeUser.Email_Id;
      obj['Key'] = key;
      console.log(obj);
      this.loginService.matchOTP(obj).subscribe((response: any) => {
        console.log('matchOTP response : ', response);
        // var data = CommonService.decryptData(response.Data);
        // var isSucces = data.split('=')[0];
        // if (isSucces.toLowerCase() === 'true'.toLowerCase()) { //response.Data
        const isSuccess = response.Data[indexNumber] === '1';
        if (isSuccess) {
          this.notification.ChangeNotification([{ Message: "Passcode verified.", Type: "SUCCESS" }])
          this.navigateToDashboard();
        }
        else {
          // alert()
          // SUCCESS
          this.notification.ChangeNotification([{ Message: "Invalid passcode.", Type: "ERROR" }])
        }
      //}
      }, (error) => {
        console.log('matchOTP error : ', error);

      })
    }

  }

  navigateToDashboard() {
    //sessionStorage.setItem('access_token', this.token);
    localStorage.clear();
    if (this.activeUser.Is_First_Login == true) {
      this.router.navigate(['/change-password']);
    }
    else {
      this.RedirectHelper.redirectByRole();
    }
  }

  keyupPasscode(event) {
    if (event.target.value.length > 6) event.target.value = event.target.value.slice(0, 6)
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    event.preventDefault(); // Prevent default form behavior if needed
    this.submit();
  }

}
